export const GRID = "grid";
export const LIST = "list";
